import React from 'react';
import { JdsTag } from '../../../components/jds/JdsTag';

const OFFER_STATUS_TAGS = {
  active: { label: 'Ativo', color: 'success' },
  expired: { label: 'Expirado', color: 'error' },
};

// Status depende só da validade (expirationDate), não do campo `active`.
export function getOfferStatus(offer) {
  if (offer?.expirationDate && new Date(offer.expirationDate) < new Date())
    return 'expired';
  return 'active';
}

export function OfferStatusBadge({ offer }) {
  const { label, color } = OFFER_STATUS_TAGS[getOfferStatus(offer)];

  return <JdsTag label={label} color={color} dot />;
}
